import { redirectToLogoutAC } from "src/actions/saga";

import { getChatToken } from "@/messenger/services/data.service";
import { TAction } from "@/messenger/types/action.types";
import { TAuthCredentials, TJWTToken, TUser } from "@/messenger/types/auth.types";

import { setUser } from "./user.duck";
// import { useSelector } from "react-redux";
// import { exoAppContextSelector } from "src/selectors";

enum ActionTypes {
    GET_USER_SESSION = "hummingbird/auth/token/GET_USER_SESSION",
    SET = "hummingbird/auth/token/SET",
}

export const setToken = (token: TJWTToken) => ({
    type: ActionTypes.SET,
    data: token,
});

export const authChat: any = (credentials: TAuthCredentials, user: TUser) => async dispatch => {

    const { userId, twilioJwt, error } = await getChatToken(credentials);
    if(error) {
        console.log(error);
        // TODO: get context in the authChat function parameter
        
        dispatch(redirectToLogoutAC({
            customerLogoutUrl: "/logout",
            federated: false,
            reason: "error",
        }));
        
    }
    dispatch(setUser({ ...user, identity: userId }));
    if (twilioJwt) {
        dispatch(setToken(twilioJwt));
    }
};

const tokenReducer = (state: TJWTToken = "", action: TAction<ActionTypes, TJWTToken>) => {
    switch (action.type) {
        case ActionTypes.SET:
            return action.data;
        default:
            return state;
    }
};

export default tokenReducer;